import { defineStore } from 'pinia';

import {
  AccountRegisterResponse,
  AccountRepository,
  AcquirerResponse,
  CompanyResponse,
  GiftIssuerAutocompleteResponse,
  IssuerResponse,
  ShopResponse,
  TenantResponse,
  WalletServiceResponse,
} from '@/repositories/generated';
import { DeepPartial } from '@/types';
import { AccountRegisterForm } from '@/validations';

type TAccountState = {
  form: AccountRegisterForm | undefined;
  initData: DeepPartial<AccountRegisterForm> | undefined;
  response: AccountRegisterResponse;
  selectedAcquirerName: AcquirerResponse | undefined;
  selectedIssuerName: IssuerResponse | undefined;
  selectedWalletServiceName: WalletServiceResponse | undefined;
  selectedGiftIssuerName: GiftIssuerAutocompleteResponse | undefined;
  selectedCompanyName: CompanyResponse | undefined;
  selectedShopName: ShopResponse | undefined;
  selectedTenantName: TenantResponse | undefined;
};

export const useAccountStore = defineStore('registAccount', {
  state: (): TAccountState => ({
    form: undefined,
    initData: undefined,
    response: {} as AccountRegisterResponse,
    selectedAcquirerName: undefined,
    selectedIssuerName: undefined,
    selectedWalletServiceName: undefined,
    selectedGiftIssuerName: undefined,
    selectedCompanyName: undefined,
    selectedShopName: undefined,
    selectedTenantName: undefined,
  }),
  actions: {
    async register(): Promise<AccountRegisterResponse> {
      const { form } = this;

      if (!form) return {} as AccountRegisterResponse;

      this.response = await AccountRepository.register({
        requestBody: {
          ...form,
          acquirerId: form.acquirerId,
          companyId: form.companyId,
          email: form.email,
          issuerId: form.issuerId,
          loginId: form.loginId,
          name: form.name,
          remarks: form.remarks,
          role: form.role,
          shopId: form.shopId,
          walletServiceId: form.walletServiceId,
          giftIssuerId: form.giftIssuerId ? Number(form.giftIssuerId) : undefined,
          tenantId: form.tenantId,
        },
      });

      return this.response;
    },
    setForm(form: AccountRegisterForm) {
      const createFrom = (_form: AccountRegisterForm) => ({
        ..._form,
      });
      this.form = createFrom(form);
      this.initData = createFrom(form);
    },
  },
});
